<script lang="ts">
    import { BulkAction } from "./BulkAction";
    import Dummy from "../../shared/Dummy.svelte";
    import Disabled from "../../shared/Disabled.svelte";

    export let action: BulkAction;

    let containerComponent: ConstructorOfATypedSvelteComponent = Dummy;
    let items: any[];
    let itemsCount: number;

    $: {
        items = action.getItems();
        itemsCount = items.length;
        containerComponent = itemsCount > 0 ? Dummy : Disabled;
    }
</script>

<svelte:component this={containerComponent}>
    <div class="bulk-action" on:click={() => action.handler(items)}>
        <svelte:component this={action.getIcon()} scale={0.7} />
        <div>{action.getLabel()}: {itemsCount}</div>
    </div>
</svelte:component>

<style>
    .bulk-action {
        grid-column-gap: 5px;
        grid-row-gap: 5px;
        cursor: pointer;
        align-items: center;
        display: flex;
        filter: invert();
    }
</style>